<script setup>
import {onMounted, onUnmounted} from 'vue';
import {useEPStore} from 'stores/ep';

const CHECK_INTERVAL_MS = 60000;

const EPStore = useEPStore();

let interval;

onMounted(() => {
	interval = setInterval(() => EPStore.checkLiveBets(), CHECK_INTERVAL_MS);
});

onUnmounted(() => clearInterval(interval));
</script>
<template>
	<div>
		Checking
	</div>
</template>
